import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, loginUser, logOutUser, registerUser } from '../store-slice/auth-slice';
// Create the context
const AuthContext = createContext(undefined);

// Custom hook to access the context
export const useAuth = () => {
	const context = useContext(AuthContext);
	if (context === undefined) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return context;
};

// AuthProvider component
export const AuthProvider = ({ children }) => {
	const{user,isAuthenticated,isLoading,error} = useSelector(state=> state.auth);
	const [isRegistering, setIsRegistering] = useState(false);
	const dispatch = useDispatch();
	const login = async (email, password) => {
		// Simulate login
		if (email && password) {
			dispatch(loginUser({ email, password }));
		}
	};

	const logout = () => {
		dispatch(logOutUser());
	};
	const register = (name, email, password) => {
		if(name && email && password) dispatch(registerUser({name,email,password}));
	};
	useEffect(()=>{
		dispatch(getUser());
	},[dispatch])
	const hasPermission = (action) => {
		if (!user) return false;
		
		const permissions = {
			admin: ['create', 'read', 'update', 'delete'],
			editor: ['create', 'read', 'update'],
			viewer: ['read'],
		};
		
		return permissions[user.role].includes(action);
	};
	const switchToLogin = () => setIsRegistering(false);
  	const switchToRegister = () => setIsRegistering(true);

	return (
		<AuthContext.Provider value={{ user, isAuthenticated:isLoading ? localStorage.getItem('token') != null : isAuthenticated, isLoading,isRegistering,error,register, login, logout,switchToLogin,switchToRegister,hasPermission }}>
			{children}
		</AuthContext.Provider>
	);
};
